import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { selectTreatmentPlan } from '../../../../treatment/state/plan/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { IPR_NOT_REQUIRED } from '../../../../treatment/state/plan/const'
import {selectStoreList} from "../../../../globals/state/selector";
import {selectCustomer} from "../../../../customer/state/detail/selector";

export default {
    taskName: taskName.CREATE_REFINEMENT_PLAN,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.PROCESS_LIST,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.IPR_INSTRUCTIONS_WIDGET,
        },
        {
            component: processUI.TREATMENT_PLAN_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
        selectTreatmentPlan,
        selectStoreList,
        selectCustomer,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context, treatmentPlan, stores, customer) => {
        const messageList = []

        if (eventName === 'plan_done') {
            const { numberOfAlignerLowerJaw, numberOfAlignerUpperJaw, treatmentDuration, iprInstructionList } = treatmentPlan

            const isZeroOrEmpty = value => !Number(value)
            const iprAdjustmentValues = Object.values(iprInstructionList || {})
            const IPRInstructionsMissing = iprAdjustmentValues.every(isZeroOrEmpty);
            const IPRDecided = context[IPR_NOT_REQUIRED] !== undefined;
            const IPRNotNeeded = context[IPR_NOT_REQUIRED];

            const isIPRProviderStore = stores.find(s => s.technicalName === customer.store).iprProvider;

            if (!numberOfAlignerLowerJaw && numberOfAlignerLowerJaw !== 0) {
                messageList.push(createValidationMessage(
                    'Please add number of aligner lower jaw.',
                    'treatmentplan.numberOfAlignerLowerJaw'
                ))
            }
            if (!numberOfAlignerUpperJaw && numberOfAlignerUpperJaw !== 0) {
                messageList.push(createValidationMessage(
                    'Please add number of aligner upper jaw.',
                    'treatmentplan.numberOfAlignerUpperJaw'
                ))
            }
            if (!treatmentDuration) {
                messageList.push(createValidationMessage(
                    'Treatment duration has not been calculated',
                    'treatmentplan.treatmentDuration'
                ))
            }

            if (isIPRProviderStore) {
                if (!IPRDecided) {
                    messageList.push(createValidationMessage(
                        'Please decide whether IPR is needed.',
                        'treatmentplan.iprInstructions'
                    ))
                } else if (!IPRNotNeeded && IPRInstructionsMissing) {
                    messageList.push(createValidationMessage(
                        'Please fill in the IPR requirements.',
                        'treatmentplan.iprInstructions'
                    ))
                }
            }

            return messageList
        }

        return messageList
    },
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/create-refinement-plan.js